import { utilNumber } from "./utilNumber";
var UtilPoint = /** @class */ (function () {
    function UtilPoint() {
        this.lerp = function (src, dest, delta) { return [
            utilNumber.lerp(src[0], dest[0], delta),
            utilNumber.lerp(src[1], dest[1], delta),
        ]; };
        this.getTopLeft = function (points) {
            var topLeft = [Infinity, Infinity];
            points.forEach(function (p) {
                topLeft[0] = Math.min(topLeft[0], p[0]);
                topLeft[1] = Math.min(topLeft[1], p[1]);
            });
            return topLeft;
        };
        this.normalizePoints = function (topLeft, points) {
            return points.map(function (p) { return [p[0] - topLeft[0], p[1] - topLeft[1]]; });
        };
        this.distance = function (a, b) {
            return Math.sqrt(Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2));
        };
        this.distanceSquared = function (a, b) {
            return Math.sqrt(Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2));
        };
        this.equals = function (a, b) {
            return a.x === b.x && a.y === b.y;
        };
    }
    return UtilPoint;
}());
export var utilPoint = new UtilPoint();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilPoint.ts
// module id = 1246
// module chunks = 3